import verifyFiles from "./verifyFilesTaxReceipt";
import linkInvoice from "./createTaxReceipt";
import uploadComplements from "./uploadComplement";
import getBilleds from "./getBilleds.js";
import deleteInvoice from "./deleteInvoice.js";
import getComplements from "./getComplements";
import createInvoiceReceipt from "./createInvoiceReceipt";
import getInvoiceReceipt from "./getInvoiceReceipt";
import uploadStampedInvoiceReceipt from "./uploadStampedInvoiceReceipt";
import cancelTaxReceipt from "./cancelTaxReceipt";
import fetchSinisterTaxReceipt from "./fetchSinisterTaxReceipt";
import validateStampedInvoice from "./validateStampedInvoice";
import requestCancellation from "./requestCancellation";
import confirmRequestCancel from "./confirmRequestCancel";
import requestReinvoicing from "./requestReinvoicing";
import createCreditNote from "./createCreditNote";
import fetchCreditNotes from "./fetchCreditNotes";
import fetchInvoiceStatus from "./fetchInvoiceStatus";
import fetchTaxReceiptFiles from "./fetchTaxReceiptFiles";

export default {
  verifyFiles,
  linkInvoice,
  uploadComplements,
  getBilleds,
  deleteInvoice,
  getComplements,
  createInvoiceReceipt,
  getInvoiceReceipt,
  uploadStampedInvoiceReceipt,
  cancelTaxReceipt,
  fetchSinisterTaxReceipt,
  validateStampedInvoice,
  requestCancellation,
  confirmRequestCancel,
  requestReinvoicing,
  createCreditNote,
  fetchCreditNotes,
  fetchInvoiceStatus,
  fetchTaxReceiptFiles,
};



// WEBPACK FOOTER //
// ./src/services/taxReceipt/index.js